import { render } from "./WeeklyParking.vue?vue&type=template&id=0b74f574"
import script from "./WeeklyParking.vue?vue&type=script&lang=js"
export * from "./WeeklyParking.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__